<template>
    <div>
        <b-btn class="btn-card-action btn-card-action-green my-1" v-if="purchase.actions.customer.publish" @click="showModal = true"> Опубликовать </b-btn>
        <b-modal ref="publish-modal" v-model="showModal" size="lg" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Опубликовать закупку">
            <div>
                <p>
                    Вы действительно хотите опубликовать закупку <strong>{{ purchase.reg_number }}</strong
                    >?
                </p>
                <p>
                    <strong>Объект закупки</strong>: {{ purchase.purchase_object }}<br />
                    <strong>Предмет закупки</strong>: {{ purchase.deliverable_group_title }}<br />
                    <template v-if="purchase.duration_type.id !== 'quotation_request'"> <strong>Сумма закупки, руб.</strong>: {{ $formatPrice(purchase.start_price) }}<br /> </template>
                    <strong>Планируемая дата заключения договора</strong>: {{ getDateFormat(purchase.planned_contract_conclusion_date) }}
                </p>
            </div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="showModal = false">Отмена</b-button>&nbsp;
                </b-overlay>
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-green" @click="publishPurchase">Опубликовать</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl223-notice-card-publish-button',
    props: {
        purchase: {
            type: Object
        }
    },
    data() {
        return {
            showModal: false,
            isLoading: false
        };
    },
    methods: {
        async publishPurchase() {
            this.isLoading = true;
            try {
                if (await this.$api.products.fl223.purchases.publish(this.purchase.id)) {
                    this.showModal = false;
                    this.$emit('publish');
                }
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
